import { useCallback, useEffect, useRef, useState } from 'react';
import { isHeavyLogCount } from './heavyLogGate';

export function useHeavyLogGate(logCount: number, onContinue: () => void) {
    const onContinueRef = useRef(onContinue);
    onContinueRef.current = onContinue;
    const [confirmOpen, setConfirmOpen] = useState(false);
    const heavy = isHeavyLogCount(logCount);

    useEffect(() => {
        if (!heavy && confirmOpen) {
            setConfirmOpen(false);
        }
    }, [heavy, confirmOpen]);

    const requestContinue = useCallback(() => {
        if (isHeavyLogCount(logCount)) {
            setConfirmOpen(true);
            return;
        }
        onContinueRef.current();
    }, [logCount]);

    const confirm = useCallback(() => {
        setConfirmOpen(false);
        onContinueRef.current();
    }, []);

    const cancel = useCallback(() => {
        setConfirmOpen(false);
    }, []);

    return { heavy, confirmOpen, requestContinue, confirm, cancel };
}
